import { IconPhone, IconClipboardCheck } from "@tabler/icons-react";
import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

export default function Quick() {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div className="block lg:hidden fixed left-0 bottom-0 w-full h-fit bg-white border rounded-t-2xl z-40">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="relative w-full h-fit grid grid-cols-5 justify-items-center pt-1.5">
        <div>
          <IconClipboardCheck onClick={openfunc} size={30} stroke={1} className="mx-auto cursor-pointer" />
          <small>견적문의</small>
        </div>
        <div>
          <img
            onClick={() => window.open("https://blog.naver.com/cjs43377")}
            alt="비우고 채우고 네이버 블로그 바로가기"
            src={"/images/quickBlog.webp"}
            loading="lazy"
            width={30}
            height={30}
            className="mx-auto cursor-pointer"
          />
          <small>블로그</small>
        </div>

        <div></div>
        <div
          onClick={() => (window.location.href = "tel:010-5229-1437")}
          className="absolute bottom-1/2 left-1/2 translate-y-2 -translate-x-7 w-14 h-14 border-4 border-point rounded-full bg-primary text-white shadow-sm grid items-center justify-items-center boxshadow cursor-pointer"
        >
          <IconPhone size={35} stroke={1} />
        </div>
        <div>
          <img
            onClick={openfunc}
            alt="비우고 채우고 출장 견적 요청"
            src={"/images/quickTalk.webp"}
            loading="lazy"
            width={26}
            height={26}
            className="mx-auto cursor-pointer"
          />
          <small>출장요청</small>
        </div>
        <div>
          <img
            onClick={() => window.open("https://open.kakao.com/o/s3yG7m0h")}
            alt="비우고 채우고 카카오톡 상담"
            src={"/images/quickKakao.webp"}
            loading="lazy"
            width={30}
            height={30}
            className="mx-auto cursor-pointer"
          />
          <small>카카오톡</small>
        </div>
      </div>
    </div>
  );
}
